(function(){
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* header */
  var hdr = document.getElementById("hdr");
  var onScroll = function(){ hdr.classList.toggle("on", window.scrollY > 8); };
  window.addEventListener("scroll", onScroll, {passive:true}); onScroll();

  /* mobile nav */
  var burger = document.getElementById("burger"), mnav = document.getElementById("mnav");
  burger.addEventListener("click", function(){
    var open = mnav.classList.toggle("open");
    burger.setAttribute("aria-expanded", open ? "true" : "false");
  });
  mnav.querySelectorAll("a").forEach(function(a){
    a.addEventListener("click", function(){ mnav.classList.remove("open"); burger.setAttribute("aria-expanded","false"); });
  });

  /* gallery: 9 PDP carousel images */
  var galImg = document.getElementById("galMain");
  var GAL_ALT = [
    "One lozenge at night, for fresh breath that does not wear off",
    "Before and after week four",
    "It was never your hygiene: the smell is made on the back of the tongue overnight",
    "Compared with mouthwash, mints and gut probiotics",
    "The K12 strain and where it was found",
    "The nightly routine in three steps",
    "What changes by week four",
    "90 days, every penny back",
    "Ingredients and CFU per lozenge"
  ];
  var galThumbs = [].slice.call(document.querySelectorAll("#thumbs .thumb"));
  function galShow(i){
    var t = galThumbs[i];
    if (!t) return;
    galThumbs.forEach(function(x){ x.classList.remove("on"); });
    t.classList.add("on");
    var im = t.querySelector("img");
    if (im) galImg.src = im.getAttribute("data-full") || im.src;
    galImg.alt = GAL_ALT[i] || "";
    if (typeof gCountSet === "function") gCountSet();
    t.scrollIntoView({block:"nearest", inline:"center", behavior: reduce ? "auto" : "smooth"});
  }
  galThumbs.forEach(function(t,i){ t.addEventListener("click", function(){ galShow(i); }); });



  /* lozenge explorer: hotspots + segmented control drive the same state */
  (function(){
    var hots = [].slice.call(document.querySelectorAll(".lx-hot"));
    var segs = [].slice.call(document.querySelectorAll(".lx-seg button"));
    var seg  = document.querySelector(".lx-seg");
    var panels = [].slice.call(document.querySelectorAll(".lx-panel"));
    if (!hots.length) return;
    function show(key){
      hots.forEach(function(h){ h.classList.toggle("on", h.getAttribute("data-strain") === key); });
      segs.forEach(function(s){ s.classList.toggle("on", s.getAttribute("data-strain") === key); });
      panels.forEach(function(p){ p.classList.toggle("on", p.getAttribute("data-panel") === key); });
      if (seg) seg.classList.toggle("m18", key === "m18");
    }
    var canHover = matchMedia("(hover:hover)").matches;
    hots.concat(segs).forEach(function(el){
      var key = el.getAttribute("data-strain");
      el.addEventListener("click", function(){ show(key); });
      if (canHover && el.classList.contains("lx-hot")) el.addEventListener("mouseenter", function(){ show(key); });
    });
    show("k12");
  })();

  /* ---- PRICING (one-time is the main offer; subscription is a small switch) ----
     One-time:     1 bottle 34.95 = 1 jar, free delivery
                   2 bottles 59.95 = 3 jars (1 free) + tongue scraper + travel tin + free delivery
                   3 bottles 69.95 = 5 jars (2 free) + tongue scraper + travel tin + free delivery
     Subscription: 29.95 / 49.95 / 59.95 for 1 / 3 / 5 jars (14% / 16% / 14% off one-time), same gifts.
     Strikes are per bottle (34.95) next to per-bottle prices. Savings % rounded down.  */
  var DATA = {
    "1": {
      title:"30-Night Try-Out", jars:1, nights:30,
      once:{ price:34.95, each:"\u00a334.95", pn:"\u00a31.17/night", disc:0 },
      sub: { price:29.95, each:"\u00a329.95", pn:"\u00a31.00/night", disc:14, every:"month", off:14 },
      ribbon:"Free UK Delivery",
      bonus:"Free UK delivery.",
      gifts:["ship"]
    },
    "2": {
      title:"90-Night Breath Transformation", jars:3, nights:90, free:1,
      once:{ price:59.95, each:"\u00a319.98", pn:"\u00a30.67/night", disc:43 },
      sub: { price:49.95, each:"\u00a316.65", pn:"\u00a30.56/night", disc:52, every:"3 months", off:16 },
      ribbon:"Pay for 2, Get 3 \u00b7 Save 43%",
      bonus:"An extra bottle, a tongue scraper, a travel tin and free UK delivery.",
      gifts:["jar1","scraper","tin","ship"]
    },
    "3": {
      title:"150-Night Lasting Transformation", jars:5, nights:150, free:2,
      once:{ price:69.95, each:"\u00a313.99", pn:"\u00a30.47/night", disc:60 },
      sub: { price:59.95, each:"\u00a311.99", pn:"\u00a30.40/night", disc:66, every:"5 months", off:14 },
      ribbon:"Pay for 3, Get 5 \u00b7 Save 60%",
      bonus:"Two extra bottles, a tongue scraper, a travel tin and free UK delivery.",
      gifts:["jar2","scraper","tin","ship"]
    }
  };
  var GIFTS = {
    ship:    { img:'<img src="https://cdn.shopify.com/s/files/1/0880/3483/6744/files/hf_20260905_055337_9290d435-7983-4248-a5b5-04a3fa53fa48.png?v=1788974794" alt="Free UK delivery" loading="lazy" decoding="async">', cap:"Free UK delivery", sub:"<s>\u00a33.95</s>" },
    tin:     { img:'<img src="https://cdn.shopify.com/s/files/1/0880/3483/6744/files/hf_20260904_155829_924cde48-570b-40a3-a3f3-070bbe42afae.png?v=1788974793" alt="Travel tin" loading="lazy" decoding="async">', cap:"Travel tin", sub:"<s>\u00a39.95</s>" },
    scraper: { img:'<img src="https://cdn.shopify.com/s/files/1/0880/3483/6744/files/virae-gift-tongue-scraper-clear.png?v=1790793239" alt="Tongue scraper" loading="lazy" decoding="async">', cap:"Tongue scraper", sub:"<s>\u00a312.00</s>" },
    jar1:    { img:'<img src="https://cdn.shopify.com/s/files/1/0880/3483/6744/files/hf_20260905_055645_2915c0c3-a904-4b66-b450-9ffffaaaf555.png?v=1788974793" alt="Extra bottle of Virae" loading="lazy" decoding="async">', cap:"+ 1 Extra bottle", sub:"30 more nights", rrp:"\u00a334.95" },
    jar2:    { img:'<img src="https://cdn.shopify.com/s/files/1/0880/3483/6744/files/hf_20260905_055645_2915c0c3-a904-4b66-b450-9ffffaaaf555.png?v=1788974793" alt="Extra bottles of Virae" loading="lazy" decoding="async">', cap:"+ 2 Extra bottles", sub:"60 more nights", rrp:"\u00a369.90" }
  };

  var qty = "2", plan = "once";
  /* gift tiles always sit side by side, same size on every tier */
  (function(){ var st = document.createElement("style");
    st.textContent = "#tiles{display:grid!important;grid-template-columns:repeat(4,minmax(0,1fr));gap:8px}#tiles .tile{width:auto!important;max-width:none!important;flex:none!important;min-width:0}";
    document.head.appendChild(st); })();
  var subToggle = document.getElementById("subToggle");
  var stickyPrice = document.getElementById("stickyPrice"), stickyTier = document.getElementById("stickyTier");
  function money(n){ return "\u00a3" + n.toFixed(2); }
  function setText(id, t){ var el = document.getElementById(id); if (el) el.textContent = t; }

  function render(){
    var d = DATA[qty], p = d[plan], n = d.gifts.length;

    document.querySelectorAll(".qty .q").forEach(function(b){
      var k = b.getAttribute("data-q"), on = k === qty;
      b.classList.toggle("on", on);
      b.setAttribute("aria-checked", on ? "true" : "false");
      b.querySelector("[data-pn]").textContent = DATA[k][plan].pn;
    });

    setText("subTitle", d.title);
    setText("subPrice", p.each);
    setText("subPerNight", p.pn);
    var was = document.getElementById("subWas");
    if (was){ was.textContent = "\u00a334.95"; was.parentNode.style.display = p.disc ? "" : "none"; }
    setText("ribbon", plan === "sub" ? ("Subscribe \u00b7 Save " + p.disc + "%") : d.ribbon);
    setText("giftPill", "+" + n + (n === 1 ? " Free Gift" : " Free Gifts"));
    var rn = document.getElementById("subRenews"); if (rn) rn.style.display = "";
    setText("subRenews", plan === "sub" ? ("Renews every " + p.every + ". Skip or cancel anytime.") : "One-time purchase. Nothing renews.");
    /* value-stacked bullets */
    var TICK = '<span class="tick"><svg viewBox="0 0 24 24"><path d="m5 13 4 4L19 7"/></svg></span>';
    var B = [];
    if (d.free) B.push("<b>" + d.free + (d.free === 1 ? " extra bottle" : " extra bottles") + " FREE</b> (" + (d.free * 30) + " more nights)");
    if (qty !== "1") B.push("<b>FREE</b> tongue scraper + travel tin, \u00a321.95 value");
    B.push("<b>FREE</b> UK delivery");
    B.push("90-day money-back guarantee");
    B.push(plan === "sub" ? ("Renews every " + p.every + ". Pause or cancel anytime.") : "One-time order. Nothing renews.");
    var cl = document.getElementById("checks");
    if (cl) cl.innerHTML = B.map(function(t){ return "<li>" + TICK + "<span>" + t + "</span></li>"; }).join("");
    setText("giftLabel", "Free with your order:");

    var tiles = document.getElementById("tiles");
    tiles.innerHTML = "";
    d.gifts.forEach(function(k){
      var g = GIFTS[k], el = document.createElement("span");
      el.className = "tile tile-" + k;
      var isPrice = /<s>/.test(g.sub), strike = g.rrp || (isPrice ? g.sub.replace(/<\/?s>/g,'') : ''); el.innerHTML = '<span class="sq">' + (strike ? '<span class="fb">Free <s>' + strike + '</s></span>' : '<span class="fb">Free</span>') + g.img + '</span><span class="cp">' + g.cap + '</span>' + (isPrice ? '' : '<span class="sb2">' + g.sub + '</span>');
      tiles.appendChild(el);
    });

    /* total value vs what you pay today */
    var VAL = d.jars * 34.95 + 3.95 + (qty !== "1" ? 12.00 + 9.95 : 0);
    var tvEl = document.getElementById("totalVal");
    if (tvEl) tvEl.innerHTML = '<span class="tv-l">Total value <s>' + money(VAL) + '</s></span>' +
      '<span class="tv-r">Today <b>' + money(p.price) + '</b></span>';

    /* the small subscribe switch: % off the one-time price */
    if (subToggle) subToggle.checked = plan === "sub";
    setText("subToggleTxt", plan === "sub"
      ? ("Subscribed and saving " + d.sub.off + "%: " + money(d.sub.price) + " every " + d.sub.every + ". Switch off for a one-time order.")
      : ("Subscribe and save " + d.sub.off + "%. Renews every " + d.sub.every + ", cancel anytime."));

    document.getElementById("mainCta").childNodes[0].nodeValue = "Add To Cart \u00b7 " + money(p.price) + " ";
    stickyTier.textContent = d.title + (plan === "sub" ? " \u00b7 Subscription" : " \u00b7 One-time");
    stickyPrice.textContent = money(p.price);
  }

  document.querySelectorAll(".qty .q").forEach(function(b){
    b.addEventListener("click", function(){ qty = b.getAttribute("data-q"); render(); });
  });
  if (subToggle) subToggle.addEventListener("change", function(){ plan = subToggle.checked ? "sub" : "once"; render(); });
  render();


  /* ============ CART ============ */
  var CART = {
    "1": { once: { id: 58674291245320, plan: null },
           sub:  { id: 58674291245320, plan: 692955349256 } },   /* 1 jar,  monthly      */
    "2": { once: { id: 58674291278088, plan: null },             /* 2 jars + 1 bonus jar */
           sub:  { id: 58674291343624, plan: 692955382024 } },   /* 3 jars, every 3 mo   */
    "3": { once: { id: 58674291310856, plan: null },             /* 3 jars + 2 bonus jars*/
           sub:  { id: 58674291376392, plan: 692955414792 } }    /* 5 jars, every 5 mo   */
  };
  var TIN = 58674735939848, SCRAPER = 58099416662280;   /* both GBP 0.00 */
  /* Bonus jars on one-time orders. Set BONUS_JAR to a GBP 0.00 "bonus jar" variant id to add
     them as their own free cart line. Until then they are recorded as a line property. */
  var BONUS_JAR = null;
  var GIFT_TIERS = { "2": true, "3": true };


  /* ============ CART DRAWER ============ */
  var SHIP_RRP = 3.95, TIN_RRP = 9.95, SCRAPER_RRP = 12.00, JAR_RRP = 34.95;
  var TIN_IMG = "https://cdn.shopify.com/s/files/1/0880/3483/6744/files/hf_20260904_155829_924cde48-570b-40a3-a3f3-070bbe42afae.png?v=1788974793";
  var SCRAPER_IMG = "https://cdn.shopify.com/s/files/1/0880/3483/6744/files/virae-gift-tongue-scraper-clear.png?v=1790793239";
  var cart = null;                       /* { qty, plan } once something is added */

  var mask=document.getElementById("cdmask"), draw=document.getElementById("cdraw"),
      cbody=document.getElementById("cdbody"), cTot=document.getElementById("cdtotal"),
      cWas=document.getElementById("cdWas"), cPer=document.getElementById("cdPer"),
      cShip=document.getElementById("cdship"), shipFill=document.getElementById("shipFill"),
      shipLbl=document.getElementById("shipLbl"), coBtn=document.getElementById("cdcheckout"),
      cartBtn=document.getElementById("cartBtn"), badge=document.getElementById("cartBadge");
  var JAR = (window.VIRAE_IMG && VIRAE_IMG["gallery-01-jar-mint"]) || "";
  var TRASH='<svg viewBox="0 0 24 24"><path d="M4 7h16M9 7V5h6v2M7 7l1 13h8l1-13" stroke-linecap="round"/></svg>';
  var RENEW = { "1":"month", "2":"3 months", "3":"5 months" };

  function fmt(n){ return "\u00a3" + n.toFixed(2); }
  function D(){ return cart ? DATA[cart.qty] : null; }
  function P(){ return cart ? DATA[cart.qty][cart.plan] : null; }
  function hasGifts(){ return !!cart && GIFT_TIERS[cart.qty]; }
  function total(){ return cart ? P().price : 0; }          /* delivery is free on every order */
  function saved(){
    if (!cart) return 0;
    var d = D(), s = d.jars * JAR_RRP - P().price + SHIP_RRP;
    if (hasGifts()) s += TIN_RRP + SCRAPER_RRP;
    return Math.round(s * 100) / 100;
  }

  var UPSELL = {
    "1": { to:"2", line:"Make it 90 nights", sub:"\u00a325.00 more: 2 extra jars (1 free), tongue scraper and travel tin" },
    "2": { to:"3", line:"Make it 150 nights", sub:"\u00a310.00 more: 2 extra jars (1 free)" }
  };

  function giftLine(img, name, rrp, note){
    return '<div class="cline"><img class="cimg" src="'+img+'" alt=""><div class="bd">'+
      '<div class="top"><div class="nm">'+name+'</div>'+
      '<div class="pr"><span class="isfree">FREE</span><span class="was">'+fmt(rrp)+'</span></div></div>'+
      '<div class="mt">'+note+'</div></div></div>';
  }

  function renderCart(){
    if (!cart){
      cbody.innerHTML = '<div class="cempty">'+
        '<svg viewBox="0 0 24 24"><path d="M6 7h12l-1 13H7L6 7z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg>'+
        '<p>Your cart is empty</p><button type="button" id="cdEmptyCta">See the options</button></div>';
      var e = document.getElementById("cdEmptyCta");
      if (e) e.addEventListener("click", function(){ closeCart(); jumpToTiers(); });
    } else {
      var d = D(), p = P(), html = "";
      var jarTxt = d.jars + (d.jars === 1 ? " jar" : " jars") + ", " + d.nights + " nights";
      var jk = "qty-" + Math.min(d.jars, 3);
      var jimg = (window.VIRAE_IMG && VIRAE_IMG[jk]) || JAR;
      var img = jimg ? '<img class="cimg" src="'+jimg+'" alt="">' : '<span class="ph"></span>';
      var wasTot = d.jars * JAR_RRP;
      html += '<div class="cline">'+img+'<div class="bd">'+
        '<div class="top"><div class="nm">Virae Oral Probiotics</div>'+
        '<button class="trash" type="button" id="cdRemove" aria-label="Remove">'+TRASH+'</button></div>'+
        '<div class="mt">'+jarTxt+(cart.plan==="sub" ? " &middot; renews every "+RENEW[cart.qty] : " &middot; one-time")+'</div>'+
        (d.free ? '<span class="off">'+d.free+(d.free===1?" extra jar":" extra jars")+' free</span>' : '')+
        '<div class="row2"><span></span><div class="pr"><b>'+fmt(p.price)+'</b>'+
        (wasTot > p.price ? '<span class="was">'+fmt(wasTot)+'</span>' : '')+'</div></div></div></div>';

      if (hasGifts()){
        html += giftLine(SCRAPER_IMG, "Virae Tongue Scraper", SCRAPER_RRP, "Step one of the nightly routine.");
        html += giftLine(TIN_IMG, "Virae Travel Tin", TIN_RRP, "Holds a week of lozenges.");
      }

      html += '<div class="cdnote">'+
        '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M8.5 12.3l2.6 2.6 4.6-5" stroke-linecap="round"/></svg>'+
        'Covered by the 90-day guarantee</div>';

      if (UPSELL[cart.qty]){
        var u = UPSELL[cart.qty];
        html += '<div class="addons"><div class="addon-h">Complete the course</div>'+
          '<div class="addon"><div class="ab"><div class="nm">'+u.line+'</div>'+
          '<div class="ap">'+u.sub+'</div></div>'+
          '<button class="add" type="button" id="cdUpsell">Upgrade</button></div></div>';
      }
      cbody.innerHTML = html;

      var rm = document.getElementById("cdRemove");
      if (rm) rm.addEventListener("click", function(){ cart = null; syncCart(); renderCart(); });
      var up = document.getElementById("cdUpsell");
      if (up) up.addEventListener("click", function(){
        var to = UPSELL[cart.qty].to;
        qty = to; cart = { qty: to, plan: cart.plan };
        render(); syncCart(); renderCart();
        try { if (window.fbq) window.fbq("track","AddToCart",{ value: total(), currency:"GBP" }); } catch(e){}
      });
    }

    /* delivery is free on every order */
    shipFill.style.width = cart ? "100%" : "0%";
    shipLbl.innerHTML = cart ? "<b>Free UK delivery included</b>" : "Free UK delivery on every order";

    var sv = saved();
    if (cWas){ if (cart && sv > 0){ cWas.style.display = ""; cWas.textContent = fmt(total() + sv); } else cWas.style.display = "none"; }
    cTot.textContent = fmt(total());
    if (cPer) cPer.textContent = cart ? (fmt(P().price / D().nights) + " a night") : "";
    if (cShip) cShip.textContent = cart ? "Free UK delivery" : "";
    if (badge){ badge.textContent = cart ? (hasGifts() ? 3 : 1) : 0; badge.classList.toggle("on", !!cart); }
    if (coBtn) coBtn.disabled = !cart;
  }

  function cartItems(){
    if (!cart) return [];
    var d = D(), sel = CART[cart.qty][cart.plan], line = { id: sel.id, quantity: 1 };
    if (sel.plan) line.selling_plan = sel.plan;
    var items = [line];
    if (cart.plan === "once" && d.free){
      if (BONUS_JAR) items.push({ id: BONUS_JAR, quantity: d.free });
      else line.properties = { "Bonus": "+" + d.free + (d.free === 1 ? " free jar" : " free jars") + " (" + d.jars + " jars in total)" };
    }
    if (hasGifts()){
      items.push({ id: SCRAPER, quantity: 1 });
      items.push({ id: TIN, quantity: 1 });
    }
    return items;
  }
  function syncCart(){
    var items = cartItems();
    return fetch("/cart/clear.js", { method:"POST", headers:{"Content-Type":"application/json"} })
      .then(function(){
        if (!items.length) return null;
        return fetch("/cart/add.js", {
          method:"POST", headers:{"Content-Type":"application/json","Accept":"application/json"},
          body: JSON.stringify({ items: items })
        });
      });
  }

  function openCart(){ renderCart(); mask.classList.add("on"); draw.classList.add("on");
    draw.setAttribute("aria-hidden","false"); document.body.style.overflow="hidden";
    if (coBtn) coBtn.focus({preventScroll:true}); }
  function closeCart(){ mask.classList.remove("on"); draw.classList.remove("on");
    draw.setAttribute("aria-hidden","true"); document.body.style.overflow=""; }
  window.viraeOpenCart = openCart; window.viraeCloseCart = closeCart;

  mask.addEventListener("click", closeCart);
  document.getElementById("cdclose").addEventListener("click", closeCart);
  document.addEventListener("keydown", function(e){ if (e.key === "Escape" && draw.classList.contains("on")) closeCart(); });
  if (cartBtn) cartBtn.addEventListener("click", openCart);

  coBtn.addEventListener("click", function(){
    if (!cart) return;
    coBtn.disabled = true; coBtn.textContent = "One moment\u2026";
    syncCart().then(function(){ window.location.href = "/checkout"; })
      .catch(function(){ coBtn.disabled = false; coBtn.textContent = "Checkout";
        shipLbl.innerHTML = "<b>Something went wrong. Please try again.</b>"; });
  });

  function addToCart(btn){
    if (btn.dataset.busy) return;
    btn.dataset.busy = "1";
    var label = btn.childNodes[0] ? btn.childNodes[0].nodeValue : null;
    if (label !== null) btn.childNodes[0].nodeValue = "Adding\u2026 ";
    cart = { qty: qty, plan: plan };
    syncCart().then(function(){ openCart(); })
      .catch(function(){ openCart(); })
      .then(function(){
        delete btn.dataset.busy;
        if (label !== null) btn.childNodes[0].nodeValue = label;
        try { if (window.fbq) window.fbq("track","AddToCart",{ value: total(), currency:"GBP" }); } catch(e){}
      });
  }
  document.querySelectorAll("[data-atc-main]").forEach(function(b){
    b.addEventListener("click", function(){ addToCart(b); });
  });
  renderCart();

  /* CTA scroll */
  var box = document.getElementById("tiers");
  function jumpToTiers(){ box.scrollIntoView({behavior: reduce ? "auto" : "smooth", block:"center"}); }
  document.querySelectorAll("[data-atc]").forEach(function(b){
    b.addEventListener("click", function(){
      box.scrollIntoView({behavior: reduce ? "auto" : "smooth", block:"center"});
      box.classList.remove("pulse"); void box.offsetWidth; box.classList.add("pulse");
    });
  });

  /* accordions */
  document.querySelectorAll("[data-acc]").forEach(function(group){
    group.querySelectorAll(".acc-i").forEach(function(item){
      var head = item.querySelector(".acc-h"), body = item.querySelector(".acc-b");
      if (item.classList.contains("open")) body.style.maxHeight = body.scrollHeight + "px";
      head.addEventListener("click", function(){
        var isOpen = item.classList.contains("open");
        group.querySelectorAll(".acc-i").forEach(function(o){
          o.classList.remove("open");
          o.querySelector(".acc-h").setAttribute("aria-expanded","false");
          o.querySelector(".acc-b").style.maxHeight = null;
        });
        if (!isOpen){
          item.classList.add("open");
          head.setAttribute("aria-expanded","true");
          body.style.maxHeight = body.scrollHeight + "px";
        }
      });
    });
  });

  /* reveal + rings */
  var circ = 2 * Math.PI * 26;
  document.querySelectorAll(".ring .fg").forEach(function(fg){
    fg.style.strokeDasharray = circ; fg.style.strokeDashoffset = circ;
  });
  function fill(stat){
    var pct = parseInt(stat.getAttribute("data-pct"), 10) || 0;
    var fg = stat.querySelector(".ring .fg");
    if (fg) fg.style.strokeDashoffset = circ * (1 - pct / 100);
  }
  if ("IntersectionObserver" in window && !reduce){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if (e.isIntersecting){
          e.target.classList.add("in");
          if (e.target.classList.contains("stat")) fill(e.target);
          io.unobserve(e.target);
        }
      });
    }, {threshold:.14});
    document.querySelectorAll(".rv").forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll(".rv").forEach(function(el){ el.classList.add("in"); });
    document.querySelectorAll(".stat").forEach(fill);
  }

  /* video carousel: centred slide plays, others pause */
  var vcar = document.getElementById("vcar");
  if (vcar){
    var slides = [].slice.call(vcar.querySelectorAll(".vslide"));
    var vdots = document.getElementById("vdots");
    slides.forEach(function(s, i){
      var d = document.createElement("button");
      d.setAttribute("role","tab");
      d.setAttribute("aria-label","Go to video " + (i + 1));
      if (i === 0) d.classList.add("on");
      d.addEventListener("click", function(){
        s.scrollIntoView({behavior: reduce ? "auto" : "smooth", inline: "center", block: "nearest"});
      });
      vdots.appendChild(d);
    });
    function setVideo(s, on){
      var v = s.querySelector("video");
      if (!v) return;
      var url = v.getAttribute("data-src") || "";
      if (on){
        if (url && url.charAt(0) !== "[" && !v.getAttribute("src")) v.setAttribute("src", url);
        if (v.getAttribute("src")){
          v.muted = true;
          var pr = v.play();
          if (pr && pr.then) pr.then(function(){ s.classList.add("playing"); }).catch(function(){});
        }
      } else {
        if (!v.paused) v.pause();
        s.classList.remove("playing");
      }
    }
    var vio = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if (e.intersectionRatio >= .6){
          var s = e.target;
          slides.forEach(function(o){
            o.classList.toggle("live", o === s);
            if (o !== s) setVideo(o, false);
          });
          var bs = vdots.querySelectorAll("button");
          slides.forEach(function(o, i){ bs[i].classList.toggle("on", o === s); });
          /* no autoplay: all three cards are visible at once, so the user picks */
        }
      });
    }, {root: vcar, threshold: [.6]});
    slides.forEach(function(s){ vio.observe(s); });
    slides.forEach(function(s){
      var frame = s.querySelector(".vframe");
      function tap(){
        var v = s.querySelector("video");
        if (!v) return;
        if (v.paused){
          slides.forEach(function(o){ if (o !== s) setVideo(o, false); });
          setVideo(s, true); v.muted = false;
        } else {
          setVideo(s, false);
        }
      }
      frame.addEventListener("click", tap);
      frame.addEventListener("keydown", function(e){ if (e.key === "Enter" || e.key === " "){ e.preventDefault(); tap(); } });
    });
    document.querySelectorAll(".vcar-btn").forEach(function(b){
      b.addEventListener("click", function(){
        var dir = b.classList.contains("next") ? 1 : -1;
        var w = slides[0].getBoundingClientRect().width + 16;
        vcar.scrollBy({left: dir * w, behavior: reduce ? "auto" : "smooth"});
      });
    });
  }

  /* hiya toggle */
  document.querySelectorAll(".hy-toggle button").forEach(function(t){
    t.addEventListener("click", function(){
      document.querySelectorAll(".hy-toggle button").forEach(function(x){
        var on = x === t;
        x.classList.toggle("on", on);
        x.setAttribute("aria-selected", on ? "true" : "false");
      });
      var k = t.getAttribute("data-hy");
      document.querySelectorAll(".hy-pane").forEach(function(p){
        p.classList.toggle("on", p.getAttribute("data-pane") === k);
      });
    });
  });

  /* hero gallery arrows */
  function gActive(){
    for (var i = 0; i < galThumbs.length; i++){ if (galThumbs[i].classList.contains("on")) return i; }
    return 0;
  }
  function gGo(d){ galShow((gActive() + d + galThumbs.length) % galThumbs.length); }
  var gPrev = document.getElementById("gPrev"), gNext = document.getElementById("gNext");
  var gCount = document.createElement("span");
  gCount.className = "gcount"; gCount.setAttribute("aria-live","polite");
  if (gNext && gNext.parentNode) gNext.parentNode.appendChild(gCount);
  function gCountSet(){ gCount.textContent = (gActive() + 1) + " / " + galThumbs.length; }
  gCountSet();
  if (gPrev) gPrev.addEventListener("click", function(){ gGo(-1); });
  if (gNext) gNext.addEventListener("click", function(){ gGo(1); });
  /* swipe on the main image (mobile has no arrows) */
  var gx = null;
  galImg.addEventListener("touchstart", function(e){ gx = e.touches[0].clientX; }, {passive:true});
  galImg.addEventListener("touchend", function(e){
    if (gx === null) return;
    var dx = e.changedTouches[0].clientX - gx; gx = null;
    if (Math.abs(dx) > 40) gGo(dx < 0 ? 1 : -1);
  }, {passive:true});

  /* timeline rail: fill follows scroll; passed steps light; current step lifts */
  var stepsEl = document.getElementById("tl");
  if (stepsEl){
    var railLine = document.getElementById("railLine");
    var railFill = document.getElementById("railFill");
    var railSteps = [].slice.call(stepsEl.querySelectorAll(".stepr"));
    var railDots = railSteps.map(function(s){ return s.querySelector(".dot"); });
    var railCenters = [];
    function dotCenter(d){
      var a = d.getBoundingClientRect(), b = stepsEl.getBoundingClientRect();
      return a.top - b.top + a.height / 2;
    }
    function railSize(){
      var top = dotCenter(railDots[0]);
      var bottom = dotCenter(railDots[railDots.length - 1]);
      railLine.style.top = top + "px";
      railLine.style.height = Math.max(0, bottom - top) + "px";
      railCenters = railDots.map(function(d){ return dotCenter(d) - top; });
    }
    function railUpdate(){
      var b = stepsEl.getBoundingClientRect();
      var lineTop = parseFloat(railLine.style.top) || 0;
      var h = parseFloat(railLine.style.height) || 1;
      var anchor = window.innerHeight * 0.62;
      var p = (anchor - (b.top + lineTop)) / h;
      p = Math.max(0, Math.min(1, p));
      railFill.style.height = (p * 100) + "%";
      var current = -1;
      railSteps.forEach(function(s, i){
        var on = p * h >= railCenters[i] - 1;
        s.classList.toggle("on", on);
        if (on) current = i;
      });
      railSteps.forEach(function(s, i){ s.classList.toggle("now", i === current); });
    }
    if (reduce){
      railSize();
      railFill.style.height = "100%";
      railSteps.forEach(function(s, i){
        s.classList.add("on");
        s.classList.toggle("now", i === railSteps.length - 1);
      });
      window.addEventListener("resize", railSize);
    } else {
      railSize(); railUpdate();
      window.addEventListener("resize", function(){ railSize(); railUpdate(); }, {passive:true});
      window.addEventListener("scroll", railUpdate, {passive:true});
      window.addEventListener("load", function(){ railSize(); railUpdate(); });
    }
  }

  /* comparison table column toggle (mobile) */
  var cmpWrap = document.getElementById("cmpWrap");
  if (cmpWrap){
    document.querySelectorAll(".tbl-toggle button").forEach(function(t){
      t.addEventListener("click", function(){
        document.querySelectorAll(".tbl-toggle button").forEach(function(x){
          var on = x === t;
          x.classList.toggle("on", on);
          x.setAttribute("aria-selected", on ? "true" : "false");
        });
        cmpWrap.classList.toggle("mode-virae", t.getAttribute("data-col") === "virae");
      });
    });
  }

  /* research library: reveal the rest */
  var rmore = document.getElementById("rmore"), rgw = document.getElementById("rgw");
  if (rmore){
    rmore.addEventListener("click", function(){
      var open = rgw.classList.toggle("open");
      rmore.setAttribute("aria-expanded", open ? "true" : "false");
      rmore.childNodes[0].nodeValue = open ? "Show less " : "See more research ";
      if (!open) rgw.scrollIntoView({behavior: reduce ? "auto" : "smooth", block: "start"});
    });
  }

  /* research modal */
  var modal = document.getElementById("modal");
  var mBody = document.getElementById("modalBody");
  var lastFocus = null;
  function mOpen(key){
    var t = document.getElementById("rsrc-" + key);
    if (!t || !modal) return;
    mBody.innerHTML = "";
    mBody.appendChild(t.content.cloneNode(true));
    modal.hidden = false;
    document.body.style.overflow = "hidden";
    lastFocus = document.activeElement;
    modal.querySelector(".modal-x").focus();
  }
  function mClose(){
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.style.overflow = "";
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.querySelectorAll("[data-research]").forEach(function(b){
    b.addEventListener("click", function(){ mOpen(b.getAttribute("data-research")); });
  });
  if (modal){
    modal.querySelectorAll("[data-mclose]").forEach(function(x){ x.addEventListener("click", mClose); });
    document.addEventListener("keydown", function(e){ if (e.key === "Escape") mClose(); });
  }

  /* sticky bar */
  var sticky = document.getElementById("sticky"), hero = document.getElementById("top");
  var toggle = function(){
    var past = window.scrollY > (hero.offsetTop + hero.offsetHeight - 80);
    var end = window.innerHeight + window.scrollY > document.body.scrollHeight - 400;
    var show = past && !end;
    sticky.classList.toggle("show", show);
    sticky.setAttribute("aria-hidden", show ? "false" : "true");
  };
  window.addEventListener("scroll", toggle, {passive:true}); toggle();
})();

/* ---- reviews widget ---- */
(function(){
  var R=[{"n": "Claire W.", "r": 5, "d": 1, "t": "The half step back stopped", "b": "Fourteen years. Dentist twice a year, always fine. I used to watch for the little lean back when I talked to people at work and I have not seen it since about week four. I didn't tell anyone I was taking anything. Nobody has commented. That's the point, I think. There's nothing to comment on.", "v": "90-Night Supply"}, {"n": "Dan R.", "r": 5, "d": 2, "t": "Gum packet still full", "b": "Bought this as a punt. Week three I found the gum in my car and it was the same packet from when I started. Didn't notice I'd stopped reaching for it.", "v": "90-Night Supply"}, {"n": "Margaret H.", "r": 5, "d": 3, "t": "My grandchildren sit closer", "b": "My blood pressure tablets dry my mouth out. Nobody said anything but I knew. Six weeks in, my daughter hugged me goodbye and did not turn her head.", "v": "150-Night Supply"}, {"n": "Tom H.", "r": 5, "d": 4, "t": "My wife noticed first", "b": "I hadn't told her I was taking anything. About five weeks in she asked if I'd changed toothpaste. That was the whole review for me really.", "v": "90-Night Supply"}, {"n": "Aisha B.", "r": 5, "d": 5, "t": "Six years and £400", "b": "A drawer full of half used rinses. This is the first thing that explained why they all failed, and then did what it said it would do.", "v": "90-Night Supply"}, {"n": "Priya S.", "r": 5, "d": 7, "t": "Stopped breathing into my hand", "b": "I used to do it before every meeting, in the lift, in the loo, everywhere. Somewhere in week three I realised I'd walked into a client meeting without doing it. I'd love to say it was a decision. It wasn't. It just fell away.", "v": "90-Night Supply"}, {"n": "Karen L.", "r": 4, "d": 8, "t": "Took longer than a week for me", "b": "The page says as little as a week and for me it was more like three. So don't panic if nothing happens at first, I nearly gave up at day ten. Now it's just part of brushing. Four stars because I'd have liked that said more clearly up front.", "v": "30-Night Supply"}, {"n": "Jacelynn K.", "r": 5, "d": 9, "t": "Nobody ever looked at the tongue", "b": "Six years of clean check-ups. The page explained more in ten minutes than any appointment I've had. The white coating I'd been scraping off every morning got lighter around week two and now I mostly don't bother.", "v": "90-Night Supply"}, {"n": "Marcus D.", "r": 5, "d": 12, "t": "Normal distance", "b": "I talk to people at normal distance now without thinking about it. I didn't realise how much I'd been angling my face away until I stopped.", "v": "90-Night Supply"}, {"n": "Hannah R.", "r": 5, "d": 14, "t": "That's the whole review", "b": "I stopped thinking about my breath. That's it.", "v": "150-Night Supply"}, {"n": "Steve P.", "r": 5, "d": 15, "t": "Smoker, and it still worked", "b": "I'll be honest, I assumed this wasn't for someone like me. Twenty a day. Mornings are different now. Not perfect, I'm not going to pretend, but my partner stopped doing the thing with the window in the car.", "v": "90-Night Supply"}, {"n": "Elaine F.", "r": 5, "d": 16, "t": "Tonsil stones", "b": "I've had those horrible little stones for years and assumed that was the whole problem. Still get the odd one but the smell that used to go with them is basically gone. Wasn't expecting that.", "v": "90-Night Supply"}, {"n": "Rob C.", "r": 4, "d": 19, "t": "Works. Wish it was cheaper.", "b": "It does what it says. Mornings are fine now. Forty-odd quid every three months is a lot on top of everything else, but it's less than I was spending on rinses that did nothing, so.", "v": "90-Night Supply"}, {"n": "Fiona M.", "r": 5, "d": 21, "t": "Bought it for my husband", "b": "Left it on his side of the sink with a note that said there's a money back thing. Didn't have to have the conversation. Six weeks later I kissed him good morning without doing the little breath hold. He has no idea that's when I noticed.", "v": "90-Night Supply"}, {"n": "James O.", "r": 3, "d": 22, "t": "Week three, still waiting", "b": "Being honest, nothing much yet. Taste is fine, easy to take, I've not missed a night. Page says it can take a few weeks so I'll stick with it for the sixty nights and update this.", "v": "30-Night Supply"}, {"n": "Sunita R.", "r": 5, "d": 24, "t": "Dry mouth from my tablets", "b": "I'm on two medications that dry my mouth right out and I'd been told that was just how it was going to be. The dryness is the same, I won't lie, but the smell that came with it has mostly gone. My son doesn't lean back any more.", "v": "150-Night Supply"}, {"n": "Ben W.", "r": 5, "d": 30, "t": "Dating again", "b": "Didn't want to write this but here we are. I'd been checking my breath before every date for years knowing it told me nothing. Two months in I've stopped. Went on a second date last week. Make of that what you will.", "v": "90-Night Supply"}, {"n": "Caroline H.", "r": 5, "d": 32, "t": "No burn, nothing to feel", "b": "First night I thought it wasn't doing anything because there's no burn, no tingle. That was the whole point apparently. Around week three my mouth just tasted clean when I woke up. Odd feeling after twenty years.", "v": "90-Night Supply"}, {"n": "Neil A.", "r": 5, "d": 34, "t": "Nobody swapped desks", "b": "New job, open plan office, old dread. Three months in and nobody has moved, nobody offers me gum, nobody does the lean. I know exactly what I'm looking for and it isn't there.", "v": "150-Night Supply"}, {"n": "Lucy G.", "r": 4, "d": 36, "t": "Good, and the subscription is easy", "b": "Works, honestly, but the thing I want to say is that I paused the subscription when I went travelling and it took about ten seconds. No emails, no forms. After some of the companies I've dealt with, that matters.", "v": "90-Night Supply"}, {"n": "Gareth T.", "r": 5, "d": 38, "t": "Night shifts", "b": "I work nights so 'take it at bedtime' means 9am for me. Still works. Take it after you brush, whatever time that is.", "v": "90-Night Supply"}, {"n": "Patricia N.", "r": 5, "d": 40, "t": "Fine for a decade, apparently", "b": "Ten years of check-ups. Ten. And the answer was a part of my mouth nobody ever looked at. I'm not angry with my dentist, he was looking where he was trained to look. I'm just relieved someone finally explained it.", "v": "150-Night Supply"}, {"n": "Owen S.", "r": 5, "d": 42, "t": "Scraper's still in the drawer", "b": "I scraped twice a day for years and it came straight back. Still scrape now and then but I don't have to. That's the difference.", "v": "90-Night Supply"}, {"n": "Mei L.", "r": 5, "d": 45, "t": "Coffee drinker", "b": "Four cups a day and I assumed that was that. Still four cups a day. Mornings are different though. Afternoon coffee breath is still coffee breath, but the morning thing is gone.", "v": "90-Night Supply"}, {"n": "Derek H.", "r": 4, "d": 47, "t": "Took a while, worth it", "b": "Nearly a month before I noticed anything. Then my daughter said something without me asking. Docked a star for how long it took, but it's holding.", "v": "90-Night Supply"}, {"n": "Rachel B.", "r": 5, "d": 60, "t": "I stopped licking my wrist", "b": "If you know, you know. I don't do it any more.", "v": "90-Night Supply"}, {"n": "Ahmed K.", "r": 5, "d": 62, "t": "Explained why the rinse made it worse", "b": "I'd been on the strong blue one twice a day for years and it kept coming back worse. The page explained why. Stopped the rinse, started this. Mornings sorted in about three weeks. Wish I'd read this a decade ago.", "v": "150-Night Supply"}, {"n": "Sophie M.", "r": 5, "d": 65, "t": "I forgot to check", "b": "Gum before every date. Breathing into my hand in the lift even though I know that tells you nothing. First two weeks, nothing, I nearly gave up. Then I got to the restaurant and realised I hadn't thought about my breath the whole way there. That's what I wanted. Not minty. Just not thinking about it.", "v": "90-Night Supply"}, {"n": "Graham P.", "r": 5, "d": 68, "t": "My wife bought it", "b": "I'd never have. Take it last thing after I've done my teeth. She says the mornings are different and she's not one for saying things she doesn't mean.", "v": "150-Night Supply"}, {"n": "Tara V.", "r": 3, "d": 70, "t": "Helped a bit, not fully", "b": "Better than it was. Not gone. I think mine might be partly sinus. I did email them and they refunded without any fuss, which I didn't expect. Keeping the stars honest.", "v": "90-Night Supply"}, {"n": "Liam F.", "r": 5, "d": 90, "t": "Two years of 'it's just morning breath'", "b": "That's what everyone said. It wasn't just morning breath, it was all day, I just couldn't smell it myself. Three months in. Mates haven't said anything. Which is exactly what I wanted.", "v": "90-Night Supply"}, {"n": "Helen D.", "r": 5, "d": 92, "t": "The checking stopped by itself", "b": "I didn't decide to stop cupping my hand. I just noticed one day I hadn't done it in a while.", "v": "90-Night Supply"}, {"n": "Chris M.", "r": 5, "d": 95, "t": "Wife bought it, I was sceptical", "b": "Thought it was another one of those. It's in with the toothbrush now. Nothing to say really, and that's the review.", "v": "90-Night Supply"}, {"n": "Nadia S.", "r": 5, "d": 120, "t": "Second jar, staying on", "b": "Bought one jar to test, went straight onto the three month one after. My sister asked what I'd changed. I hadn't told her anything.", "v": "90-Night Supply"}, {"n": "Peter J.", "r": 5, "d": 125, "t": "Six months in, still holds", "b": "Wanted to wait before writing this. Six months. Still one a night, still fine. The bit I care about is that it hasn't drifted back.", "v": "150-Night Supply"}];
  var STAR='<svg viewBox="0 0 24 24"><path d="M12 2l2.9 6.3 6.9.8-5.1 4.7 1.4 6.8L12 17.2 5.9 20.6l1.4-6.8L2.2 9.1l6.9-.8z"/></svg>';
  var grid=document.getElementById('rwGrid'),more=document.getElementById('rwMore'),sort=document.getElementById('rwSort');
  if(!grid) return;
  var PAGE=8,shown=0,order=R.slice();
  function rel(d){if(d<=1)return'Yesterday';if(d<7)return d+' days ago';if(d<14)return'1 week ago';if(d<30)return Math.round(d/7)+' weeks ago';if(d<60)return'1 month ago';return Math.round(d/30)+' months ago';}
  function esc(s){return s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');}
  function card(r,i){
    var stars='';for(var k=0;k<5;k++)stars+=STAR;
    return '<article class="rw-card" data-i="'+i+'">'+
      '<div class="rw-who">'+esc(r.n)+'<span class="rw-vb">Verified Buyer <svg viewBox="0 0 24 24"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm-1.2 14.6-4-4 1.4-1.4 2.6 2.6 5.8-5.8 1.4 1.4-7.2 7.2z"/></svg></span></div>'+
      '<div class="rw-prod"><span class="rw-thumb"><svg viewBox="0 0 24 24" fill="none" stroke="#1F6B3F" stroke-width="1.6"><rect x="6" y="7" width="12" height="13" rx="2.5"/><path d="M8 7V5.5A1.5 1.5 0 0 1 9.5 4h5A1.5 1.5 0 0 1 16 5.5V7"/><circle cx="12" cy="14" r="2.6"/></svg></span>'+
      '<div class="rw-prod-t">Reviewing<b>Virae Nightly Lozenge</b><i>'+esc(r.v)+'</i></div></div>'+
      '<div class="rw-meta"><span class="stars" style="color:'+(r.r>=4?'var(--amber)':'var(--amber)')+'">'+stars.split('</svg>').slice(0,r.r).join('</svg>')+'</svg>'+(r.r<5?'<span style="opacity:.25">'+stars.split('</svg>').slice(0,5-r.r).join('</svg>')+'</svg></span>':'')+'</span><span class="rw-date">'+rel(r.d)+'</span></div>'+
      '<h3 class="rw-t">'+esc(r.t)+'</h3><p class="rw-b">'+esc(r.b)+'</p>'+
      '<button class="rw-rm" type="button">Read More</button>'+
      '<div class="rw-help">Was this helpful? <button type="button" data-h="up"><svg viewBox="0 0 24 24"><path d="M7 11v9H4v-9h3zm2 0 3.5-7a2 2 0 0 1 2 2v4h4.2a2 2 0 0 1 2 2.3l-1 6.4A2 2 0 0 1 17.7 20H9v-9z"/></svg><span>0</span></button><button type="button" data-h="dn"><svg viewBox="0 0 24 24"><path d="M17 13V4h3v9h-3zm-2 0-3.5 7a2 2 0 0 1-2-2v-4H5.3a2 2 0 0 1-2-2.3l1-6.4A2 2 0 0 1 6.3 4H15v9z"/></svg><span>0</span></button></div>'+
    '</article>';
  }
  function render(){
    grid.innerHTML=order.map(card).join('');
    shown=0; reveal();
  }
  function reveal(){
    var cards=grid.querySelectorAll('.rw-card');
    for(var i=shown;i<Math.min(shown+PAGE,cards.length);i++)cards[i].classList.add('show');
    shown=Math.min(shown+PAGE,cards.length);
    more.hidden=shown>=cards.length;
    clampCheck();
  }
  function clampCheck(){
    grid.querySelectorAll('.rw-card.show:not(.open)').forEach(function(c){
      var b=c.querySelector('.rw-b');
      c.classList.toggle('long',b.scrollHeight>b.clientHeight+2);
    });
  }
  window.addEventListener('resize',function(){clearTimeout(window.__rwT);window.__rwT=setTimeout(clampCheck,150);});
  more.addEventListener('click',reveal);
  sort.addEventListener('change',function(){
    var v=sort.value;
    order=R.slice().sort(function(a,b){return v==='high'?(b.r-a.r)||(a.d-b.d):v==='low'?(a.r-b.r)||(a.d-b.d):a.d-b.d;});
    render();
  });
  grid.addEventListener('click',function(e){
    var rm=e.target.closest('.rw-rm');
    if(rm){var c=rm.closest('.rw-card');c.classList.toggle('open');rm.textContent=c.classList.contains('open')?'Read Less':'Read More';return;}
    var h=e.target.closest('[data-h]');
    if(h&&!h.classList.contains('hit')){h.classList.add('hit');var n=h.querySelector('span');n.textContent=(+n.textContent)+1;}
  });
  render();
})();

/* ---- cloudless-skeleton behaviours ---- */
(function(){
  // statement: scroll-linked word fill
  var h=document.querySelector('[data-fill]');
  if(h){h.innerHTML=h.textContent.split(' ').map(function(w){return '<span class="w">'+w+'</span>'}).join(' ');
    var ws=h.querySelectorAll('.w');
    function fill(){var r=h.getBoundingClientRect(),vh=window.innerHeight,p=Math.min(1,Math.max(0,(vh*0.8-r.top)/(vh*0.6)));var n=Math.round(p*ws.length);ws.forEach(function(w,i){w.classList.toggle('on',i<n)});}
    window.addEventListener('scroll',fill,{passive:true});fill();}
  // real people carousel arrows
  var trs=[].slice.call(document.querySelectorAll('.rp-track'));var tr=trs[0];trs.forEach(function(t,ti){t._shift=ti?-0.5:0;var orig=[].slice.call(t.children);if(!orig.length)return;t._n=orig.length;for(var r=0;r<2;r++){orig.forEach(function(c){var k=c.cloneNode(true);k.setAttribute('aria-hidden','true');[].forEach.call(k.querySelectorAll('a,button'),function(e){e.tabIndex=-1});t.appendChild(k);});}function setW(){var c=t.querySelector('.rp-c');if(!c)return 0;var g=parseFloat(getComputedStyle(t).columnGap)||0;t._step=c.getBoundingClientRect().width+g;t._set=t._step*t._n;return t._set;}function home(){setW();var c=t.querySelector('.rp-c');if(!c)return;t.scrollLeft=t._set-(t.clientWidth-c.getBoundingClientRect().width)/2+(t._shift||0)*t._step;}home();var lock=false;t.addEventListener('scroll',function(){if(lock||!t._set)return;if(t.scrollLeft<t._set*0.5){lock=true;t.scrollLeft+=t._set;lock=false;}else if(t.scrollLeft>t._set*1.5){lock=true;t.scrollLeft-=t._set;lock=false;}},{passive:true});var rt;window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(home,180);});});
  document.querySelectorAll('[data-rp]').forEach(function(b){b.addEventListener('click',function(){var d=+b.getAttribute('data-rp');trs.forEach(function(t){var st=t._step;if(!st){var c=t.querySelector('.rp-c');st=c?c.getBoundingClientRect().width+(parseFloat(getComputedStyle(t).columnGap)||0):304;}t.scrollBy({left:d*st,behavior:'smooth'});});})});
  // formula spotlight
  var FM=[["k12", "BLIS K12\u2122", "3 billion CFU", "A strain of Streptococcus salivarius isolated from a child at the University of Otago who never got sore throats. Settles on the back of the tongue and produces salivaricin A2 and B, natural antibacterials that suppress the bacteria turning protein into sulfur gas.", "https://cdn.shopify.com/s/files/1/0880/3483/6744/files/hf_20260905_140501_83f5bbdf-859f-41ef-8e86-f970f7facebe.png?v=1788974794"], ["m18", "BLIS M18\u2122", "3 billion CFU", "The gum strain. Settles on the teeth and gum line and produces an enzyme that loosens plaque. Three-month controlled trials report less gum bleeding and plaque.", "https://cdn.shopify.com/s/files/1/0880/3483/6744/files/hf_20260905_140500_5dcc8852-9cfc-4967-9396-7855fe98999a.png?v=1788974794"], ["lozenge", "Lozenge, not capsule", "Dissolves in 3 to 5 minutes", "A capsule is swallowed and never touches the tongue. A lozenge keeps the strains in the mouth for the minutes they need to attach, then you sleep on it.", "https://cdn.shopify.com/s/files/1/0880/3483/6744/files/hf_20260905_140500_da5dbaa4-686c-4c3e-9f40-26c03614166c.png?v=1788974794"]];
  var lis=document.querySelectorAll('.fm-list li'),name=document.getElementById('fmName'),dose=document.getElementById('fmDose'),txt=document.getElementById('fmText'),st=document.getElementById('fmStudy');
  function setFm(i){lis.forEach(function(l,j){l.classList.toggle('on',j===i)});name.textContent=FM[i][1];dose.textContent=FM[i][2];txt.textContent=FM[i][3];st.setAttribute('data-research',FM[i][0]);var im=document.getElementById('fmImg');if(im&&FM[i][4])im.src=FM[i][4];}
  if(lis.length){setFm(0);lis.forEach(function(l,i){l.querySelector('button').addEventListener('click',function(){setFm(i)})});
    }
  // bento + trigger cards open research drawers when they carry data-research
})();

(function(){var lb=document.getElementById('lb'),im=document.getElementById('lbImg');if(!lb)return;
document.querySelectorAll('[data-lb]').forEach(function(b){b.addEventListener('click',function(){im.src=b.querySelector('img').src;im.alt=b.querySelector('img').alt;lb.hidden=false;document.body.style.overflow='hidden';})});
function close(){lb.hidden=true;document.body.style.overflow='';}
lb.addEventListener('click',function(e){if(e.target===lb||e.target.classList.contains('lb-x'))close()});
document.addEventListener('keydown',function(e){if(e.key==='Escape')close()});})();

/* sticky: invert over dark sections */
(function(){var st=document.getElementById('sticky');if(!st)return;var darks=[].slice.call(document.querySelectorAll('.gc,.dk,footer'));
function chk(){var y=window.innerHeight-48;var inv=darks.some(function(d){var r=d.getBoundingClientRect();return r.top<=y&&r.bottom>=y});st.classList.toggle('inv',inv);}
window.addEventListener('scroll',chk,{passive:true});window.addEventListener('resize',chk);chk();})();

(function(){var g=document.querySelector('.glass'),w=g&&g.parentNode;if(!g||!w)return;function chk(){var atEnd=g.scrollLeft+g.clientWidth>=g.scrollWidth-3;w.classList.toggle('end',atEnd);if(g.scrollLeft>8)w.classList.add('moved');}g.addEventListener('scroll',chk,{passive:true});window.addEventListener('resize',chk);chk();})();

(function(){var tabs=document.querySelectorAll('.faq-tabs [role=tab]'),panels=document.querySelectorAll('.faq-g');if(!tabs.length)return;tabs.forEach(function(t,i){t.addEventListener('click',function(){tabs.forEach(function(x,j){x.classList.toggle('on',j===i);x.setAttribute('aria-selected',j===i?'true':'false');});panels.forEach(function(p,j){p.classList.toggle('on',j===i);if(j===i)p.removeAttribute('hidden');else p.setAttribute('hidden','');});});});})();